export default "__VITE_ASSET__5ce40556__"